import React, { Component } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { BsShieldCheck } from "react-icons/bs";
import { withRouter, Link } from "react-router-dom";
// import { Redirect } from 'react-router'

import "./Carousel.css";
import {
  appendImageUrl,
  getSavedData,
  isMobiledevice,
} from "../../utils/helperFunctions";
import BgSqd from "../../assets/bg_sqd.png";
import Bgcircle from "../../assets/grps.png";



 class Carousels extends Component {
  myfunc(url){
    let urls = url.split("#")
    console.log(urls, "urls")
    this.props.history.push(urls[1])
  }
  render() {
    console.log(this.props.history, "carasol")
    const { sqd } = this.props;
    console.log(sqd, "SQUARDs");

    var settings = {
      className: "",
      dots: true,
      autoplay: true,
      infinite: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      adaptiveHeight: true,
      appendDots: (dots) => (
        <div>
          <ul> {dots} </ul>
        </div>
      ),
      customPaging: (i) => (
        <div
          style={{
            border: "2px solid grey",
            backgroundColor: "grey",
            padding: "0px 80px",
          }}
          className="update-slick"
        ></div>
      ),
    };
    return (
      <div>
        <Slider {...settings}>
          {sqd.map((x, i) => {
            if (x.member_name) {
              return (
                <div key={i} className="box-inner">
                  <div className="main-box-bg">
                    <div className="herosContainer">
                      <img
                        src={appendImageUrl(x.image)}
                        alt="Heros"
                        className="herosU"
                      />
                      <img src={BgSqd} alt="bg" className="herosBgU" />
                      <div className="bx_firstU">
                        <h3 className="sq_name">{x.member_name}</h3>
                        <p className="sq_desig">{x.designation}</p>
                        {x.vaccinated && (
                          <div
                            style={{ display: "flex", alignItems: "center" }}
                          >
                            <BsShieldCheck className="shield" />
                            <p className="sq_Vac">Fully Vaccinated</p>
                          </div>
                        )}
                      </div>
                      <div className="box_inner_lastU">
                        {`${x.years_of_experience ? x.years_of_experience : "3"
                          } Years of`}
                        <br />
                        Experience
                      </div>
                    </div>
                  </div>
                </div>
              );
            } else if (x.title) {
              return (
                <div key={i} className="box_main">
                  <div className="box_vertical">
                    <div className="box_vert_img">
                      <img
                        src={
                          x.image
                            ? x.image
                            : appendImageUrl(
                              "/files/files/hemant_lead_crew_CeuniDs.png"
                            )
                        }
                        alt="Vertical"
                        className="vert_img"
                      />
                    </div>
                    <div className="vert_content">
                      <div>
                        <h1 className="vert_head">{x.title}</h1>
                        <div className="vert_desc">{x.description}</div>
                      </div>
                      <div
                        style={{
                          textAlign: "center",
                          marginTop: isMobiledevice() ? "1rem" : "3rem",
                        }}
                      >
                        {(x.redirect_url === null) ? <button
                          onClick={() =>
                            window.open(
                              `https://wa.me/${getSavedData("baseData")
                                ? getSavedData("baseData").whatsapp
                                  ?.description
                                : "+917738398406"
                              }?text=I'm%20interested%20in%20${x.title}`
                            )
                          }
                          className="vert_btn"
                        >
                          {x.button_text}
                        </button>: <button className="vert_btn" onClick={() => this.myfunc(x.redirect_url)}>{x.button_text}</button>}
                      </div>
                    </div>
                  </div>
                </div>
              );
            } else {
              return (
                <div key={i} className="box_main">
                  <div class="Ellipse-1"></div>
                  <img src={Bgcircle} alt="Bgcircle" className="Ellipse-2" />
                  <div className="Ellipse-3"></div>
                  <div className="Ellipse-4"></div>
                  <div className="box_testimonial">
                    <div className="bx_test_img">
                      <img
                        src={
                          x.profile_image?.image
                            ? x.profile_image?.image
                            : appendImageUrl(
                              "/files/files/hemant_lead_crew_CeuniDs.png"
                            )
                        }
                        alt="Testimonial"
                        className="Test_images"
                      />
                    </div>
                    <div className="test_content">
                      <h3 className="test_head">{`${x.user_id?.first_name} ${x.user_id?.last_name}`}</h3>
                      <div className="text_test">{x.feedback}</div>
                    </div>
                  </div>
                </div>
              );
            }
          })}
        </Slider>
      </div>
    );
  }
}

export default withRouter(Carousels)